const TYPES = Object.freeze([{ code: 1, label: "申请退款" }, { code: 2, label: "申请平台协调" }]);
const REASONS = Object.freeze([{ code: 1, label: "质量不满意" }, { code: 2, label: "服务未按约定提供" }, { code: 3, label: "交付内容有问题" }, { code: 4, label: "其他" }]);
const cents = value => {
    const text = String(value == null ? "" : value).trim();
    if (!/^\d+(\.\d{1,2})?$/.test(text)) return null;
    const parts = text.split(".");
    const amount = Number(parts[0]) * 100 + Number((parts[1] || "").padEnd(2, "0"));
    return Number.isSafeInteger(amount) ? amount : null;
};
const formatCents = amount => `${Math.floor(amount / 100)}.${String(amount % 100).padStart(2, "0")}`;
const money = value => { const amount = cents(value); return amount == null ? "" : formatCents(amount); };
const validateOptions = (options, no) => {
    if (!options || options.serviceOrderNo !== no || typeof options.eligible !== "boolean"
        || ["servicePaidAmount", "remainingServiceRefundAmount", "extraPaidAmount", "remainingExtraRefundAmount"].some(field => cents(options[field]) == null)) throw new Error("售后资格或金额数据无效，请刷新重试");
    return options;
};
const payload = state => {
    const options = state.afterSalesOptions;
    if (!options || !options.eligible) throw new Error(options && options.ineligibleReason || "当前不可申请售后，请刷新资格");
    if (!TYPES.some(item => item.code === state.afterSalesTypeCode) || !REASONS.some(item => item.code === state.afterSalesReasonCode)) throw new Error("请选择售后诉求类型和申请原因");
    const amount = state.afterSalesTypeCode === 2 ? 0 : cents(state.requestedServiceRefundAmount || "0");
    const extra = state.afterSalesTypeCode === 2 ? 0 : cents(state.requestedExtraRefundAmount || "0");
    if (amount == null || (state.afterSalesTypeCode === 1 && amount + extra <= 0) || extra == null || amount > cents(options.remainingServiceRefundAmount) || extra > cents(options.remainingExtraRefundAmount)) throw new Error("至少一项退款须大于零，各项最多两位小数且不超过该项剩余可退实付");
    return { description: state.description.trim(), afterSalesTypeCode: state.afterSalesTypeCode, afterSalesReasonCode: state.afterSalesReasonCode,
        requestedServiceRefundAmount: formatCents(amount), requestedExtraRefundAmount: formatCents(extra) };
};
module.exports = { TYPES, REASONS, cents, money, validateOptions, payload };
